<!-- =========================================================================================
  File Name: UserList.vue
  Description: Modules List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div>

    <vs-popup ref="mainPopup" class="fields" :title="$t('MODULES.Fields')" :active.sync="showIntegrationModal">

      <vs-table striped v-model="selectedRows" :sst="false" @search="handleSearch" @change-page="handleChangePage"
        @sort="handleSort" max-items="10" max-height="500px" :data="moduleFields">

        <template slot="thead">
          <vs-th sort-key="name">{{ $t('MODULES.name') }}</vs-th>
          <vs-th sort-key="hash">{{ $t('MODULES.hash') }}</vs-th>
          <vs-th sort-key="info">Info</vs-th>
          <vs-th sort-key="info">Copy</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g,
      "_").replace("?", "") }} =
            </vs-td>

            <vs-td :data="data[indextr].hash">
              "{{ data[indextr].hash }}"
            </vs-td>

            <vs-td>
              <feather-icon :icon="'PlusIcon'" v-show="data[indextr].fieldInfo"
                svgClasses="h-5 w-5 mr-4 text-success cursor-pointer" @click="fieldInfo(data[indextr].hash)" />
            </vs-td>
            <vs-td>
              <feather-icon :icon="'CopyIcon'" svgClasses="h-5 w-5 mr-4 text-primary cursor-pointer"
                @click="copyFieldHash(data[indextr].hash)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vs-popup>

    <vs-popup class="list-items" :title="$t('MODULES.listItems')" :active.sync="showOptionsModal">

      <vs-table striped :sst="false" @search="handleSearch" @change-page="handleChangePage" @sort="handleSort"
        max-items="10" max-height="500px" :data="fieldOptions">

        <template slot="thead">
          <vs-th sort-key="name">{{ $t('MODULES.name') }}</vs-th>
          <vs-th sort-key="hash">Hash</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].label">
              {{ data[indextr].label.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g,
      "_").replace("?", "") }} =
            </vs-td>

            <vs-td :data="data[indextr].value">
              "{{ data[indextr].value }}"
            </vs-td>

            <vs-td>
              <feather-icon :icon="'PlusIcon'" v-show="data[indextr].fieldInfo"
                svgClasses="h-5 w-5 mr-4 text-success cursor-pointer" @click="fieldInfo(data[indextr].hash)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </vs-popup>


    <div class="vx-row p-4" style="float:right!important;">
      <div class="vx-col-12" style="float:right!important;">
        <vs-button color="primary" style="float:right!important;" type="filled" icon-pack="feather"
          icon="icon-plus-circle" @click="$router.push('/module-management/add')">{{ $t('MODULES.add') }}</vs-button>
      </div>
    </div>
    <br><br><br>
    <div class="vx-row">

    </div>
    <div class="vx-card p-6">
      <vs-table multiple v-model="selectedRows" :sst="false" @search="handleSearch" @change-page="handleChangePage"
        @sort="handleSort" pagination :max-items="20" search :data="modules">

        <template slot="header">
          <h3>{{ $t('MODULES.moduleManagement') }}</h3>
        </template>

        <template slot="thead">
          <vs-th sort-key="name">{{ $t('MODULES.name') }}</vs-th>
          <vs-th sort-key="hash">Hash</vs-th>
          <vs-th sort-key="created_at">{{ $t('MODULES.created_at') }}</vs-th>
          <vs-th sort-key="type">{{ $t('MODULES.type') }}</vs-th>
          <vs-th sort-key="session_type">{{ $t('MODULES.session_type') }}</vs-th>
          <vs-th sort-key="actions">{{ $t('MODULES.actions') }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <template v-for="field in data[indextr]">
                <vs-td :key="field" :data="field">
                  {{ field }}
                </vs-td>
              </template> -->

            <vs-td :data="data[indextr].name">
              <feather-icon :icon="data[indextr].icon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer" /> {{
      data[indextr].name }}
            </vs-td>

            <vs-td :data="data[indextr].hash">
              {{ data[indextr].hash }}
            </vs-td>

            <vs-td :data="data[indextr].created_at">
              {{ data[indextr].created_at }}
            </vs-td>

            <vs-td :data="data[indextr].type">
              {{ data[indextr].type }}
            </vs-td>

            <vs-td :data="data[indextr].session_type">
              {{ data[indextr].session_type }}
            </vs-td>

            <!-- <vs-td>
                <vs-chip :color="colors[indextr]" class="product-order-status">{{ labels[indextr] }}</vs-chip>
              </vs-td> -->
            <vs-td>
              <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"
                @click="$router.push(`/module-management/view/${data[indextr]['hash']}`)" />
              <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                @click="$router.push(`/module-management/edit/${data[indextr]['hash']}`)" />
              <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
                @click="confirmDeleteRecord(data[indextr]['hash'])" />
              <feather-icon icon="GridIcon" v-if="data[indextr].type !== 'Kanban'"
                :svgClasses="'h-5 w-5 mr-3 cursor-pointer hover:text-primary'"
                @click="$router.push(data[indextr].type === 'Calendário' ? `/module-field-management-calendar/${data[indextr]['hash']}` : `/module-field-management/${data[indextr]['hash']}`)" />
              <feather-icon icon="ListIcon" :svgClasses="'h-5 w-5 mr-3 cursor-pointer hover:text-primary'"
                v-if="data[indextr].type !== 'Calendário' && data[indextr].type !== 'Único Registro' && data[indextr].type !== 'Kanban'"
                @click="$router.push(`/module-list-management/${data[indextr]['hash']}`)" />
              <feather-icon icon="CodeIcon" :svgClasses="'h-5 w-5 mr-3 cursor-pointer hover:text-primary'"
                @click="showIntegrationFields(data[indextr]['hash'])" />
              <feather-icon icon="SettingsIcon" :svgClasses="'h-5 w-5 cursor-pointer hover:text-primary'"
                @click="$router.push(`/module-actions/${data[indextr]['hash']}`)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { setApplicationLocalStorageItem, performFetch } from '../../../helpers'
export default {
  data: () => ({
    moduleInfo: {
      moduleName: ''
    },
    selected: [],
    log: [],
    modules: [],
    tableTitles: [],
    selectedRows: [],
    rowHashToDelete: '',
    showIntegrationModal: false,
    moduleFields: [],
    showOptionsModal: false,
    fieldOptions: []
  }),
  watch: {
    selectedRows(value) {
      // console.log(value)
    },
    showOptionsModal(value) {
      if (!value) {
        this.showIntegrationModal = true
        this.fieldOptions = []
      } else {
        this.showIntegrationModal = false
      }
    }
  },
  mounted() {
    document.querySelector('.vx-card').style.backgroundColor = '#fff'
    document.title = `${document.title.split(' | ')[0]} | Módulos`
  },
  methods: {
    copyFieldHash(fieldHash) {
      navigator.clipboard.writeText(fieldHash).then(() => {
        this.$vs.notify({
          title: this.$t('MODULES.successCopyLabel') + '!',
          text: this.$t('MODULES.copyLabelPopupText') + '!',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'success'
        });
      });
    },
    fieldInfo(fieldHash) {
      const fieldObject = this.moduleFields.find(x => x.hash === fieldHash)

      if (fieldObject.hasOwnProperty('options')) {
        fieldObject.options.forEach(option => {

          if (fieldObject.typeId === 24) {
            if (option.hasOwnProperty('groupLevel') && option.groupLevel > 1) {
              this.fieldOptions.push({
                label: option.label,
                value: option.value
              })
            } else if (!option.hasOwnProperty('groupLevel')) {
              this.fieldOptions.push({
                label: option.label,
                value: option.value
              })
            }
          } else {
            this.fieldOptions.push({
              label: option.label,
              value: option.value
            })
          }
        })
      }

      this.showOptionsModal = true
    },
    async showIntegrationFields(moduleHash) {

      await performFetch(this.$store.state.auth.api_url, {
        command: 'module_management_get_application_module_fields',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token,
          module_token: moduleHash
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.moduleFields = []

              responseData.module.payload.forEach(block => {
                block.fields.forEach(field => {

                  let fieldInfo = false

                  if (field.type_id === 24 || field.type_id === 25 || field.type_id === 29 || field.type_id === 30) {
                    fieldInfo = true
                  }

                  this.moduleFields.push({
                    hash: field.hash,
                    name: block.title + '__' + field.title,
                    fieldInfo,
                    options: field.options,
                    typeId: field.type_id
                  })
                })
              })

              this.moduleFields.sort((a, b) => {
                if (a.name < b.name) {
                  return -1
                }

                if (a.name > b.name) {
                  return 1
                }

                return 0
              })

              this.$vs.loading.close()

              this.showIntegrationModal = true
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

    },
    handleSearch(searching) {
      console.log(`The user searched for: ${searching}`)
    },
    handleChangePage(page) {
      console.log(`The user changed the page to: ${page}`)
    },
    handleSort(key, active) {
      console.log(`the user ordered: ${key} ${active}`)
    },
    checkIfStringIsDate(string) {

      try {
        if ((string.split('-').length - 1) == 2 && (string.split(':').length - 1) == 2 && (string.split(' ').length - 1) == 1) {
          return true
        } else {
          return false
        }
      } catch (e) {
        return false
      }
    },
    confirmDeleteRecord(rowHash) {
      this.rowHashToDelete = rowHash
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('MODULES.confirmDeletionTitle'),
        text: this.$t('MODULES.confirmDeletionText'),
        accept: this.deleteRecord,
        acceptText: this.$t('MODULES.Delete')
      })
    },
    async deleteRecord() {

      this.$vs.loading({ type: 'default' })

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        session_token: this.$store.state.auth.token,
        module_token: this.$route.params.moduleHash,
        module_hash: this.rowHashToDelete
      }

      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_delete_application_module',
      //     parameters: requestBody
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'module_management_delete_application_module',
        parameters: requestBody
      })
        .then(async (response) => {
          if (response.status === 200) {
            response.json().then(async (response) => {

              // await fetch(this.$store.state.auth.api_url, {
              //   method: 'POST', headers: {"Content-Type": "application/json"},
              //   body: JSON.stringify({
              //     command: 'get_application_user_mainmenu',
              //     parameters: {
              //       application_token: this.$store.state.auth.app_token,
              //       session_token: this.$store.state.auth.token
              //     }
              //   })
              // })
              await performFetch(this.$store.state.auth.api_url, {
                command: 'get_application_user_mainmenu',
                parameters: {
                  application_token: this.$store.state.auth.app_token,
                  session_token: this.$store.state.auth.token
                }
              })
                .then(async (response) => {
                  if (response.status === 200) {
                    await response.json().then(async (response) => {

                      await this.$store.dispatch('auth/buildApplicationMenu', response.mainmenu)

                      this.$vs.loading.close()

                      this.$vs.notify({
                        title: this.$t('MODULES.SuccessOperation'),
                        text: response.message,
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                      })

                      this.$store.dispatch('auth/reloadState')

                      this.$vs.loading({ type: 'default' })

                      this.getModules()
                    })
                  } else if (response.status == 401) {
                    this.$vs.loading.close()
                    setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
                    this.$store.dispatch('auth/signOut')
                  } else {
                    this.$vs.loading.close()
                    this.$vs.notify({
                      title: this.$t('MODULES.FailedOperation'),
                      text: this.$t('MODULES.ModuleDeletedErrorMenuUpdate'),
                      iconPack: 'feather',
                      icon: 'icon-alert-circle',
                      color: 'danger'
                    })
                  }
                })
                .catch((error) => {
                  this.$vs.loading.close()
                  this.$vs.notify({
                    title: this.$t('MODULES.FailedOperation'),
                    text: this.$t('MODULES.ModuleDeletedErrorMenuUpdate'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  })
                })
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            //this.$vs.loading.close()
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('MODULES.FailedOperation'),
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })

      this.rowHashToDelete = ''
    },
    async getModules() {
      // fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'module_management_get_application_modules',
      //     parameters: {
      //       application_token: this.$store.state.auth.app_token,
      //       session_token: this.$store.state.auth.token
      //     }
      //   })
      // })
      await performFetch(`${this.$store.state.auth.api_url}`, {
        command: 'module_management_get_application_modules',
        parameters: {
          application_token: this.$store.state.auth.app_token,
          session_token: this.$store.state.auth.token
        }
      })
        .then((response) => {
          if (response.status === 200) {
            response.json().then((responseData) => {

              this.modules = []

              if (responseData.modules.length > 0) {
                responseData.modules.forEach((item) => {

                  if (item.created_at) {
                    const date = item.created_at.split(' ')[0].trim()
                    const hours = item.created_at.split(' ')[1].trim()
                    item.created_at = `${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]} ${hours}`
                  }

                  const moduleRow = {
                    hash: item.hash,
                    name: item.name,
                    created_at: item.created_at,
                    type: item.type.name,
                    session_type: item.session_type.name,
                    icon: item.icon
                  }

                  this.modules.push(moduleRow)
                })
              }

              this.$vs.loading.close()
            })
              .catch(e => {
                console.log(e)
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Atenção!',
                  text: e.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'danger'
                })
                throw new Error(e.message)
              })
          } else if (response.status === 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          }
        })
        .catch((e) => {
          console.log(e)
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Atenção!',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          throw new Error(e.message)
        })
    }
  },
  created() {
    this.$vs.loading({ type: 'default' })
    this.getModules()
  }
}
</script>

<style scoped>
/* #page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
} */

.con-vs-popup>>>.vs-popup {
  width: 1000px !important;
  height: 600px !important;
}
</style>
